import React, { useState, useEffect }  from 'react';
import { useHistory } from "react-router-dom";
import clsx from 'clsx';
import CrudTable from "../../crud/CrudTable"
import {clinicService as service} from "../../../services"

const initFilter =  {
    name : null,
    email: null,
    city:null,
};

export default function Clinic() {

  const createEstructureFilter =  [
     {
       type:"input",
       name: "name",
       label: "Nombre",
       col: 4
      },
     {
       type:"input",
       name: "email",
       label: "Email",
       col: 4
      },
       {
         type:"input",
         name: "city",
         label: "Población",
         col: 4
        },
  ];



  return (
    <CrudTable
          service={service}
          titlePage={"Clinicas"}
          titleButton={"Nueva clinica"}
          urledit={"/clinics/edit/"}
          urlnew={"/clinics/new/"}
          filter={initFilter}
          fieldstable={["picture","name","email","street","postalcode"]}
          headersTable={["#","Nombre","Email", "Dirección","C.P"]}
          estructureForm={createEstructureFilter}
      />
  );
}
